<template>
  <v-sheet
    color="white"
    elevation="1"
    class="pa-5 two-factor"
  >

    <v-chip
      color="#3D9970"
      dark
      v-if="is2faEnabled"
      class="state"
    >
      Enabled
    </v-chip>
    <v-chip
      v-if="!is2faEnabled"
      class="state"
      color="#FF4136"
      dark
    >
      Disabled
    </v-chip>
    <h3>Two Factor Authentication</h3>

    <div v-if="!is2faEnabled">
      <p>Two factor authentication is not enabled on this account. Please contact us to prompt two factor access</p>
    </div>

    <div v-else>
      <p>Two factor authentication is enabled on this account. Manage your settings and recovery codes below</p>

      <h4>Your Recovery Codes</h4>

      <p>You have {{ remainingCodes }} of 8 codes remaining</p>

      <div v-if="newCodes.length > 0">
        <p>Your new recovery codes are below</p>
        <p><strong style="color: red">These will not be available again, so either copy them below or download and store them in a safe place</strong></p>
        <p>These codes should be treated in the same way as your password, so store them in a safe environment</p>
        <RecoveryCodeView :recovery-codes="newCodes"></RecoveryCodeView>
      </div>

      <div v-else>
        <v-btn outlined color="warning" @click="regenerateCodes" type="submit" >Regenerate Recovery Codes</v-btn>
      </div>

      <h4>Reset Two Factor</h4>

      <p>If you need to change your two factor device, please contact us so we can verify identity</p>

    </div>

    <div>

    </div>
  </v-sheet>
</template>

<script>
import { get } from "vuex-pathify";
import RecoveryCodeView from "@/views/components/RecoveryCodeView";

export default {
  name: "ManageTwoFactor",
  components: {
    RecoveryCodeView
  },
  computed: {
    is2faEnabled: get('auth/user.is2faEnabled'),
    remainingCodes: get('auth/user.remainingCodes'),
  },
  data: () => ({
    twoFactorCode: "",
    visibility: {
      current: String
    },
    newCodes: []
  }),
  methods: {
    regenerateCodes() {
      this.$swal({
        title: "Regenerate Recovery Codes",
        icon: "warning",
        input: "html",
        html:
          '<div id="swal-content1">NOTE: This will invalidate your existing codes and generate new codes</div>' +
          '<input id="swal-input1" class="swal2-input" type="password" placeholder="Your Password" style="text-align: center">' +
          '<div id="swal-error"></div>',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Regenerate",
        showLoaderOnConfirm: true,
        customClass: {
          input: "d-none"
        },
        preConfirm: async () => {
          const pass = document.getElementById("swal-input1").value;

          const result = await this.$store.dispatch("auth/recoveryCodeReset", {
            pass: pass,
          });

          if (result.success) {
            this.newCodes = result.codes;
            await this.$store.dispatch("notification/triggerSuccess", { title: "Recovery Codes Reset", detail: "Please download / copy them to a secure place" });
          }

          return true;
        },
        inputValidator: () => {
          if (!document.getElementById("swal-input1").value) {
            return "Please confirm your password";
          }
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  font-size: 0.9rem;
  color: #777;
  margin-top: 10px;
}

.two-factor {
  position: relative;

  .state {
    position: absolute;
    right:20px;
    top:20px;
  }

}

h4 {
  margin-top: 20px;
}

</style>
